
import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import GridHeader from '@/models/gridHeader'

interface Options {
  page: number,
  itemsPerPage: number,
  sortBy: string[],
  sortDesc: boolean[],
  groupBy: string[],
  groupDesc: boolean[],
  multiSort: boolean,
  mustSort: boolean
}

@Component
export default class CardTable extends Vue {
  @Prop() private tableFooter!: {} | undefined
  @Prop() private tableHeaders!: GridHeader[]
  @Prop() private tableItems!: []
  @Prop() private tableLoading!: boolean
  @Prop() private tableSearch!: string
  @Prop() private tableNoDataText!: string
  @Prop() private tableNoResultsText!: string
  @Prop() private tableLoadingText!: string
  private tableHeight: number | string = '100%'

  public setTableHeight() {
    if (this.$refs.table === undefined || this.$refs.tableTop === undefined) {
      this.tableHeight = '70vh'
    }
    // @ts-ignore
    // const tableSize: number = this.$refs.table.$el.clientHeight
    const tableSize: number = window.innerHeight
    // @ts-ignore
    const tableChildNodes = Array.from(this.$refs.table.$el.childNodes)
    // @ts-ignore
    const tableFooterSize: number = tableChildNodes.find((el) => el.className === 'v-data-footer')!.clientHeight
    // @ts-ignore
    const tableTopSize: number = this.$refs.tableTop.clientHeight
    // @ts-ignore
    const tableFiltersChip: number = this.$refs.tableFiltersChip.clientHeight
    // @ts-ignore
    const height = tableSize - (tableTopSize + tableFiltersChip + tableFooterSize)
    this.tableHeight = height
  }

  private mounted() {
    this.setTableHeight()
  }

  private itemSelected(payload: any) {
    payload.items = [payload.item]
    delete payload.item
    this.$emit('item-selected', payload)
  }

  private allItemsSelected(payload: any) {
   this.$emit('item-selected', payload)
  }

  private dblClickedRow(payload: any, itemOptions: any) {
    const item = itemOptions.item
    this.$emit('row-doubleClicked', item)
  }

  private updatePage(page: number) {
    this.$emit('page-updated', page)
  }

  private updateOptions(options: Options) {
    this.$emit('pageSize-updated', options.itemsPerPage)
  }

  private updateSort(sortBy: string | string[]) {
    this.$emit('sort-updated', sortBy)
  }

  private updateSortDesc(sortDesc: boolean | boolean[]) {
    this.$emit('sortDesc-updated', sortDesc)
  }

  private onResize() {
    this.setTableHeight()
  }

}
